"use client";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";

import UserItem from "./UserItem";
import Link from "next/link";

export default function Sidebar() {
  const menuList = [
    {
      items: [
        {
          link: "/",
          text: "Home",
        },
      ],
    },
    {
      group: "Projects",
      items: [
        {
          link: "/rsa-tools",
          text: "RSA Tools",
        },
        {
          link: "/web-chat",
          text: "Web Chat",
        },
        {
          link: "/pdf-compressor",
          text: "PDF Compressor",
        },
        {
          link: "/pdf-encrypter-decrypter",
          text: "PDF Encrypter Decrypter",
        },
      ],
    },
  ];
  return (
    <div className="flex flex-col sm:w-[280px] w-[80px] min-w-[80px] sm:min-w-[280px] border-r min-h-screen p-2 sm:p-4 gap-2">
      <div className="flex items-center justify-center sm:justify-start">
        <UserItem />
      </div>
      <div className="flex-grow">
        <Command style={{ overflow: "visible" }}>
          <CommandInput placeholder="Type a command or search..." />
          <CommandList style={{ overflow: "visible" }}>
            <CommandEmpty>No results found.</CommandEmpty>
            {menuList.map((menu: any, key: number) => (
              <CommandGroup key={key} heading={menu.group}>
                {menu.items.map((option: any, optionKey: number) => (
                  <Link key={optionKey} href={option.link}>
                    <CommandItem key={optionKey} className="cursor-pointer">
                      {option.text}
                    </CommandItem>
                  </Link>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </div>
    </div>
  );
}
